import { createContext, useContext } from 'react';

import { Environment, ShopBundle } from '../types';

import { Config } from './Config';
import { selectConfig } from './utils';

type ConfigContexttData = {
  config: Config;
};

const ConfigContext = createContext<ConfigContexttData>({
  config: {} as Config,
});

export const useConfig = () => useContext(ConfigContext);

interface ConfigContextProviderProps {
  env: Environment;
  shopBundle: ShopBundle;
}

const ConfigProvider: React.FC<ConfigContextProviderProps> = ({ env, children, shopBundle }) => {
  const config = selectConfig(env)(shopBundle);

  return <ConfigContext.Provider value={{ config }}>{children}</ConfigContext.Provider>;
};

export default ConfigProvider;
